import styled from "@emotion/styled";
import colors from "styles/colors";
export const StyledBottomCenterPoints = styled.ul`
  .bottom-center-point-button {
    color: ${colors["black"]};

    &:focus {
      color: ${colors["brand-blue"]};
    }
  }
`;
